exports.version = "0.6.0"


//////////////////
// WEBPACK FOOTER
// ./~/apollo-client/version.js
// module id = 835
// module chunks = 4